import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddCommasDirective } from '../../directives/add-commas.directive';

@Component({
  selector: 'app-generic-input-field',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, AddCommasDirective],
  templateUrl: './generic-input-field.component.html',
  styleUrl: './generic-input-field.component.scss',
})
export class GenericInputFieldComponent {
  @Input() id: string = '';
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() type: string = 'text';
  @Input() control!: FormControl;
  @Input() disabled: boolean = false;
  @Input() showLabel: boolean = true;
  @Input() issCurrency: boolean = false;
  @Input() showPasswordEye: boolean = false;

  public passwordVibility = false;

  @Output() onSelectedValue = new EventEmitter<any>();

  errorMessages: Record<string, string> = {
    required: 'This field is required',
    email: 'Enter a valid email',
    percent: 'Value cannot be more that 100',
    mismatch: 'Password does not match',
    invalidPhone: 'Invalid phone number',
    amountGreater: 'Amount is greater than available subhead balance',
  };

  constructor() {}

  numberOnly(event: any): boolean {
    const regex = /^[0-9]*\.?[0-9]*$/;

    // Allow only numbers and a single decimal point
    if (event.key === '.' && event.target.value.includes('.')) {
      return false; // Prevent multiple decimal points
    }

    const result = regex.test(event.key);
    return result;
  }

  onSelectedFile(event: Event) {
    this.onSelectedValue.emit(event);
  }

  setPasswordVibility() {
    this.passwordVibility = !this.passwordVibility;
    if (this.passwordVibility) this.type = 'text';
    else this.type = 'password';
  }

  trackByFn(index: number): number {
    return index;
  }
}
